/* eslint-disable no-console */
import React, { useEffect, useContext, useState } from 'react';
import i18n from '../utils/i18n';
import { Store } from '../Store';
import SweetAlerts from './SweetAlerts';

const isLocal = process.env.REACT_APP_ENVIRONMENT === 'local';

console.log('App version: ', process.env.REACT_APP_VERSION, process.env.REACT_APP_ENVIRONMENT);

function VersionCheck({ path }) {
  const { state, dispatch } = useContext(Store);
  const [newVersionAvailable, setNewVersionAvailable] = useState(false);

  useEffect(() => {
    (async () => {
      if (
        isLocal ||
        (state.settings.versionLastChecked &&
          Date.now() - state.settings?.versionLastChecked < 60000 * 10)
      ) {
        return;
      }

      const txt = await getTimestampFile();

      // console.log('txt', txt);
      console.log('process.env.REACT_APP_VERSION', process.env.REACT_APP_VERSION);
      const newVersionExist = txt?.trim() !== process.env.REACT_APP_VERSION?.trim();
      // console.log('newVersionExist => ', newVersionExist);

      if (newVersionExist) {
        setNewVersionAvailable(txt);
      }

      dispatch({ type: 'VERSION_CHECKED' });
    })();
  }, [path]);

  const getTimestampFile = async () => {
    const res = await fetch(`${process.env.PUBLIC_URL}/${process.env.REACT_APP_RELEASE_FILE}`);

    if (!res.ok) {
      return false;
    }

    const txt = await res.text();
    return txt;
  };

  return (
    <>
      {newVersionAvailable && (
        <SweetAlerts
          type="default"
          title={i18n.t('default.new-version-title')}
          text={i18n.t('default.new-version-text', { version: newVersionAvailable })}
          onConfirm={() => {
            window.location.reload(true);
          }}
        />
      )}
    </>
  );
}

export default VersionCheck;
